const TITLE_CASE_SMALL_WORDS = new Set([
  "a",
  "an",
  "and",
  "as",
  "at",
  "but",
  "by",
  "for",
  "in",
  "of",
  "on",
  "or",
  "the",
  "to",
  "vs",
]);

/** Normalize in-page section headings to title case (mobile `PageHeader` / screen titles). */
export function toContentSectionTitle(heading: string): string {
  const trimmed = heading.trim();
  if (!trimmed) return "";
  return trimmed
    .split(/\s+/)
    .map((word, index) => {
      const lower = word.toLowerCase();
      if (index > 0 && TITLE_CASE_SMALL_WORDS.has(lower)) return lower;
      if (!word.length) return word;
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(" ");
}
